import { FC, memo } from 'react';

import {
  Button,
  ButtonProps,
  CircularProgress,
  createStyles,
  makeStyles,
} from '@material-ui/core';

export type UIButtonProps = {
  loading?: boolean;
  outlined?: boolean;
  label: string;
  icon?: JSX.Element;
  errorStyle?: boolean;
} & ButtonProps;

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    errorButton: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      border: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark,
        border: theme.palette.error.main,
      },
    },
  })
);

export const ErrorButton: FC<UIButtonProps> = memo(
  ({
     label,
     icon,
     outlined,
     disabled = false,
     onClick,
     loading,
     errorStyle,
     ...props
   }): JSX.Element => {
    const classes = useStyles();

    return (
      <Button
        {...props}
        variant={outlined ? 'outlined' : 'contained'}
        disabled={disabled}
        color="primary"
        onClick={onClick}
        className={errorStyle? classes.errorButton : ''}
      >
        {icon}
        {label}
        {loading && (
          <CircularProgress
            size={24}
            // @ts-ignore
            className={classes.buttonProgress}
          />
        )}
      </Button>
    );
  }
);

ErrorButton.displayName = 'ErrorButton';

export default ErrorButton;
